import {useState } from "react";
import Spinner from "../Spinner";
import { doConv } from "./MarketConfirmPage";
import { MarketBasketItem } from "./MarketModal";

interface CryptoCheckoutFormProps {
  userInfo: any;
  skipPayment: boolean;
  currency: string;
  basket?: MarketBasketItem;
  currencyEstimates: [
    {
      symbol: string;
      name: string;
      exhangeRate: number;
    }
  ];
  cryptoPayment: (currency: string, ownerEmail: string, ownerName: string) => Promise<void>;
  next: () => void;
}

export const CryptoCheckoutForm: React.FC<CryptoCheckoutFormProps> = ({
  cryptoPayment,
  currencyEstimates,
  basket,
  userInfo,
  skipPayment,
  currency,
  next,
}) => {
  const [email, setEmail] = useState(userInfo.email);
  const [emailFocus, setEmailFocus] = useState(false);
  const [name, setName] = useState(userInfo.fullName);
  const [nameFocus, setNameFocus] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (skipPayment) {
      next();
      return;
    }

    if(!email || !name) {
      setMessage("Email and full name are required")
      return
    }

    setIsLoading(true)
    await cryptoPayment(currency, email, name).catch((e) => {
      setMessage("Email address incorrect")
    })
    setIsLoading(false)
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit} style={formStyle}>
      <div
        style={{
          color: "#000000",
          fontSize: "16px",
          fontFamily: "GT Planar Medium",
        }}
      >

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflowX: 'clip',
          overflowY: 'scroll',
          padding: 24,
        }}>
        {
          <div
            style={{
              display: "flex",
              gap: 10,
              flexDirection: "column",
              width: "100%",
            }}
          >
            <label style={labelStyle}>Email</label>
            <input
              onChange={(e) => {
                setMessage("")
                setEmail(e.target.value);
              }}
              disabled={userInfo.email}
              placeholder={"Your email address"}
              value={email}
              style={searchInputStyle(emailFocus)}
              onFocus={() => {
                setEmailFocus(true);
              }}
              onBlur={() => setEmailFocus(false)}
            />
            <br />
          </div>
        }
        {
          <div
            style={{
              display: "flex",
              gap: 10,
              flexDirection: "column",
            }}
          >
            <label style={labelStyle}>Full Name</label>
            <input
              onChange={(e) => {
                setMessage("")
                setName(e.target.value);
              }}
              disabled={userInfo.fullName}
              placeholder={"Your full name"}
              value={name}
              style={searchInputStyle(nameFocus)}
              onFocus={() => {
                setNameFocus(true);
              }}
              onBlur={() => setNameFocus(false)}
            />
            <br />
          </div>
        }
        </div>

      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: 24,
        paddingRight: 24,
      }}>
        <button
          style={payButtonStyle}
          disabled={isLoading}
          id="submit"
        >
          <span id="button-text">
            {isLoading ? (
              <Spinner width="30px" height="30px" border="4px" />
            ) : (
              `Pay ${basket && doConv(basket?.currency!, basket?.price!, basket?.nameService!, basket?.years!, basket?.region!, currencyEstimates)}` 
            )}
          </span>
        </button>
        {message && (
          <div style={errorStyle} id="payment-message">
            {message}
          </div>
        )}
      </div>
    </form>
  );
};

const errorStyle: React.CSSProperties = {
  padding: 10,
  display: "flex",
  justifyContent: "center",
  fontFamily: "GT Planar Regular",
  color: "#CF1558",
  fontSize: "16px",
  paddingBottom: "20px",
};

const formStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%"
};

const payButtonStyle: React.CSSProperties = {
  display: "flex",
  alignContent: "center",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: 4,
  cursor: "pointer",
  height: 48,
  background: "linear-gradient(108.64deg, #854EFB 7.51%, #8A88FF 98.44%)",
  boxShadow:
    "0px 122.973px 98.3784px rgba(0, 0, 0, 0.07), 0px 51.3752px 41.1001px rgba(0, 0, 0, 0.0503198), 0px 27.4676px 21.9741px rgba(0, 0, 0, 0.0417275), 0px 15.3981px 12.3185px rgba(0, 0, 0, 0.035), 0px 8.17783px 6.54226px rgba(0, 0, 0, 0.0282725), 0px 3.40298px 2.72238px rgba(0, 0, 0, 0.0196802)",
  borderRadius: 12,
  border: "1.5px solid #8A88FF",
  color: "#FFFFFF",
  width: "100%",
};

const labelStyle: React.CSSProperties = {
  fontSize: "16px",
  fontFamily: "GT Planar Regular",
  color: "rgba(0, 0, 0, 0.7)",
};

const searchInputStyle = (hasFocus: boolean): React.CSSProperties => ({
  display: "flex",
  height: 48,
  background: "#FFFFFF",
  borderColor: "#FFFFFF",
  outline: "none",
  border: hasFocus ? "1.5px solid #8A88FF" : "1px solid rgba(0, 0, 0, 0.2)",
  fontFamily: "GT Planar Medium",
  borderRadius: 12,
  width: "-webkit-fill-available",
  paddingLeft: 10,
  margin: 0,
});
